import { SiteContextConfig } from '@spartacus/core';

const baseSite = ['sd'];

export const siteContextConfig: SiteContextConfig = {
  context: {
    baseSite,
    urlParameters: ['baseStore'],
    currency: ['RUB'],
    language: ['ru'],
    catalogId: ['sdvrProductCatalog'],
    catalogVersionId: ['Online'],
  },
};
